import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, ButtonBase, Chip } from '@mui/material';

const ViewNoteDialog = ({ open, selectedNote, setSelectedNote, setOpenViewNoteDialog, colors }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpenViewNoteDialog(false);
        setSelectedNote(null);
      }}
    >
      <DialogTitle>{selectedNote?.title || ''}</DialogTitle>
      <DialogContent>
        <Typography variant="h6" gutterBottom>
          Content:
        </Typography>
        <Typography paragraph>{selectedNote?.note_content || ''}</Typography>
        {selectedNote?.link && (
          <>
            <Typography variant="h6" gutterBottom>
              Link:
            </Typography>
            <Typography
              component="a"
              href={selectedNote.link}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: colors.indigo[400], textDecoration: 'underline' }}
            >
              {selectedNote.link}
            </Typography>
          </>
        )}
        {selectedNote?.image && (
          <>
            <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>
              Attached File:
            </Typography>
            <ButtonBase>
              <Chip
                label={selectedNote.image}
                clickable
                component="a"
                href={`https://www.mindsinaction.com.na/assets/document/${selectedNote.image}`}
                target="_blank"
              />
            </ButtonBase>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpenViewNoteDialog(false);
            setSelectedNote(null);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewNoteDialog;